module.exports = __webpack_public_path__ + "img/product_22.0c746ba.jpg";